import { useState } from 'react';
import { Container, Button, Input, Alert, InputGroup } from 'reactstrap';
import { supabase } from '../lib/supabaseClient';
import generateAskString from '../utils/generateAskString';

function HomePage() {
  const [question, setQuestion] = useState('');
  const [shareUrl, setShareUrl] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    const trimmed = question.trim();
    if (!trimmed) return;

    setLoading(true);
    setError(null);

    const string = generateAskString();
    const { error: insertError } = await supabase
      .from('questions')
      .insert([{ question: trimmed, string }]);

    if (insertError) {
      setError(insertError.message);
      setLoading(false);
      return;
    }

    const baseUrl = window.location.origin;
    const url = `${baseUrl}/please/${string}`;
    setShareUrl(url);
    setLoading(false);
  }

  function handleCopyLink() {
    if (shareUrl) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  }

  function handleNewAsk() {
    setQuestion('');
    setShareUrl(null);
    setError(null);
  }

  return (
    <div className="min-vh-100 d-flex align-items-center px-2">
      <Container className="py-5 text-center">
        <h1 className="display-4 mb-2">Pretty Pwease</h1>
        <h2 className="h5 text-muted mb-4">Manipulation, but make it adorable.</h2>
        <p className="mb-4 mx-auto" style={{ maxWidth: '720px' }}>We combine advanced persuasion mechanics, escalating button dominance,
          and weaponized cuteness to ensure your question receives the correct answer.
          Powered by love. And slightly unfair UX.</p>

        {error && (
          <Alert color="danger" toggle={() => setError(null)} className="mb-4 mx-auto" style={{ maxWidth: '720px' }}>
            {error}
          </Alert>
        )}

        {!shareUrl ? (
          <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
            <Input
              type="textarea"
              rows={4}
              placeholder="e.g. Will you marry me? Can I have the last slice?"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              disabled={loading}
              className="mb-3 w-100"
              style={{ maxWidth: '520px' }}
            />
            <Button type="submit" color="primary" disabled={!question.trim() || loading} className="btn-home">
              {loading ? 'Creating link…' : 'Generate link'}
            </Button>
          </form>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <Alert color="success" className="mb-4 w-100" style={{ maxWidth: '520px' }}>
              Link generated successfully. Emotional leverage activated.
            </Alert>
            <InputGroup className="mb-2" style={{ maxWidth: '520px' }}>
              <Input
                type="text"
                readOnly
                value={shareUrl}
                className="font-monospace"
              />
              <Button color="primary" onClick={handleCopyLink} className="btn-home">
                {copied ? 'Copied!' : 'Copy Magic Link'}
              </Button>
            </InputGroup>
            <p className="text-muted mb-1" style={{ fontSize: '12px' }}>Link valid for 24 hours.</p>
            <p className="text-muted mb-3" style={{ fontSize: '12px' }}>No refunds if they still click No.</p>
            <div>
              <Button color="secondary" outline onClick={handleNewAsk} className="me-2">
                Manipulate someone else
              </Button>
              <Button color="primary" tag="a" href={shareUrl} target="_blank" rel="noopener noreferrer" className="btn-home">
                Preview Request
              </Button>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}

export default HomePage;
